import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { ImageDetail } from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	goToWebsite() {
		window.open('https://www.lincolnshire.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'Lincolnshire County Council',
		src: 'assets/lincolnshire-logo.svg',
	};

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://www.lincolnshire.gov.uk/site-search/results/?q=${formatted}`;
		window.location.href = url;
	}
}
